import { React, useRef, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import UserPhoto from "../../Assets/userphoto.png";
import { CircularProgress, TextField, Typography } from "@mui/material";
import Facebook from "../../Assets/Svg/Facebook.svg";
import Instagram from "../../Assets/Svg/instagram.svg";
import Telegram from "../../Assets/Svg/Telegram.svg";
import Whatsaap from "../../Assets/Svg/whatsaap.svg";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import Files from "react-files";
import { useNavigate } from "react-router-dom";
import MainLoader from "../common/main-loader";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading, setProfileData } from "../../store/slices/profileSlice";
import ProfileHeader from "./profile-parts/header";
import EditCard from "./profile-parts/edit-card";
import EditForm from "./profile-parts/edit-form";
import {useCenteredSnackbar} from "../../tools/useCenteredSnackbar";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileData = useSelector((state) => state.profile.profileData);
  const [editedProfile, setEditedProfile] = useState({
    ...profileData,
    photoPreview: null,
  });
  const isProfileDataLoading = useSelector((state) => state.profile.isLoading);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [countries, setCountries] = useState([]);
  const { showCenteredPopup } = useCenteredSnackbar();

  useEffect(() => {
    getCountries();
  }, []);

  // Update editedProfile when both profileData and countries are available
  useEffect(() => {
    if (profileData && countries.length > 0) {
      // Find the country ID by name from the countries list
      const countryName = profileData.country;
      const foundCountry = countries.find(country => country.name === countryName);

      setEditedProfile(prev => ({
        ...prev,
        ...profileData,
        // Use the country ID if found, otherwise keep the original value
        country: foundCountry ? foundCountry.id : profileData.country,
        photoPreview: null,
      }));
    }
  }, [profileData, countries]); // REMOVED editedProfile FROM DEPENDENCIES

  const handleEdit = async () => {
    const formData = new FormData();
    // Add all fields from editedProfile except photoPreview and photo
    Object.keys(editedProfile).forEach((key) => {
      if (
          key !== "photo" &&
          key !== "photoPreview" &&
          key !== "description" &&
          editedProfile[key]?.length !== 0
      ) {
        formData.append(key, editedProfile[key]);
      } else if (editedProfile[key]?.length === 0) {
        formData.append(key, "null");
      } else if (key === 'notify_by_email'){
        formData.append(key, editedProfile.notify_by_email ? 1 : 0)
      } else if (key === 'notify_by_push'){
        formData.append(key, editedProfile.notify_by_push ? 1 : 0)
      }
    });

    // Append only the binary file for photo
    if (selectedPhoto) {
      formData.append("photo", selectedPhoto);
    }

    setIsEditLoading(true);
    const { response, message } = await Helper.Post({
      url: api_Routes.profile.updateprofile,
      hasToken: true,
      data: formData,
    });

    if (response) {
      // Find the country name by ID for display
      const countryName = countries.find(country => country.id === parseInt(response.user.country_id))?.name || response.user.country;

      dispatch(
          setProfileData({
            id: response.user.id,
            name: response.user.name,
            email: response.user.email,
            photo: response.user.photo,
            description: response.user.description,
            whatsapp: response.user.whatsapp,
            telegram: response.user.telegram,
            instagram: response.user.instagram,
            facebook: response.user.facebook,
            tiktok: response.user.tiktok,
            skype: response.user.skype,
            sex: response.user.sex,
            about: response.user.about,
            // Store both ID and name for different purposes
            country: response.user.country_id, // Store the ID for the form
            country_name: countryName, // Store the name for display
            notify_by_email: response.user.notify_by_email == "1" ? true : false,
            notify_by_push: response.user.notify_by_push == "1" ? true : false,
          })
      );

      // ALSO UPDATE THE LOCAL EDITEDPROFILE STATE WITH THE NEW COUNTRY ID
      setEditedProfile(prev => ({
        ...prev,
        country: response.user.country_id, // Update with the new country ID from response
      }));

      setSelectedPhoto(null);
      showCenteredPopup(message,
          { variant: "success",
            persist: true });
    } else {
      console.error(message);
      showCenteredPopup(message || "Failed to update Profile",
          { variant: "error",
            persist: true });
    }
    setIsEditLoading(false);
  };

  const handleInputChange = (field, value) => {
    setEditedProfile((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleGlobalToggle = (key) => (event) => {
    setEditedProfile(prev => ({
      ...prev,
      [key]: event.target.checked,
    }));
  };

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      const file = files[0];
      setSelectedPhoto(file);
      setEditedProfile((prev) => ({
        ...prev,
        photoPreview: URL.createObjectURL(file),
      }));
    }
  };

  const handleFileError = (error) => {
    console.error("File upload error:", error);
  };

  const getCountries = () => {
    Helper.Get({
      url: api_Routes.Countries.view,
      hasToken: true,
      data: {
        results: 190,
      },
    }).then(({ response, message }) => {
      if (response) {
        setCountries(response);
      } else {
        console.error("Failed to fetch Countries data:", message);
      }
    });
  };

  return (
      <>
        {isProfileDataLoading ? (
            <MainLoader />
        ) : (
            <>
              <ProfileHeader
                  handleFileChange={handleFileChange}
                  handleFileError={handleFileError}
                  editedProfile={editedProfile}
              />
              <EditCard
                  editedProfile={editedProfile}
                  handleEdit={handleEdit}
                  isEditLoading={isEditLoading}
              />
              <EditForm
                  countries={countries}
                  handleInputChange={handleInputChange}
                  editedProfile={editedProfile}
                  handleGlobalToggle={handleGlobalToggle}
              />
            </>
        )}
      </>
  );
};
export default Profile;